import { render, staticRenderFns } from "./Plavix.vue?vue&type=template&id=2c2d79be&"
import script from "./Plavix.vue?vue&type=script&lang=js&"
export * from "./Plavix.vue?vue&type=script&lang=js&"
import style0 from "./Plavix.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports